import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as eduActions from 'modules/edu';
import * as common from 'libs/commonFunc';
import { Message, List } from 'semantic-ui-react';
import { ModalTemplate, Loading, Button as Btn } from 'components';


import classNames from 'classnames/bind';
import styles from './EduQuiz.css';
const cx = classNames.bind(styles);

class EduQuizDeleteModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false
    };
  }

  deleteQuiz = async () => {
    this.setState({ loading: true });

    const { quizInfo, toggleDeleteModal } = this.props;

    const params = {
      quizNo: quizInfo.quizNo
    };

    try {
      const { EduActions } = this.props;
      await EduActions.deleteEduQuiz(params);
    } catch (e) {
      console.log(e);
    }

    this.setState({ loading: false });
    toggleDeleteModal();
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const { quizInfo, toggleDeleteModal } = this.props;
    const { loading } = this.state;
    const { deleteQuiz } = this;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-admin tiny', 'common-content')}
        closeIcon
        onToggleModal={toggleDeleteModal}
        visible
        header={<div>{defineMessages(formatMessage({ id: 'Quiz_11', defaultMessage: '퀴즈 삭제' }))}</div>}
        buttons={
          <div className={cx('inline-block')}>
            <Btn buttonColor="#bbbbbb" onClick={toggleDeleteModal}>
              {defineMessages(formatMessage({ id: 'ModalEdu_1', defaultMessage: '취소' }))}
            </Btn>
            <Btn className={cx('gray-button')} loading={loading} disabled={loading} onClick={deleteQuiz}>
              {defineMessages(formatMessage({ id: 'ModalEdu_5', defaultMessage: '삭제' }))}
            </Btn>
          </div>
        }>
        <Loading
          active={loading}
          size="small"
        // content={defineMessages(formatMessage({ id: 'ExamTemplateDelete_4', defaultMessage: '삭제중...' }))}
        />
        <div className={cx('message-header')}>
          {defineMessages(
            formatMessage({
              id: 'ModalEdu_7',
              defaultMessage: '삭제한 퀴즈는 복구할 수 없습니다.'
            })
          )}
          <br />
          {defineMessages(
            formatMessage({
              id: 'ModalEdu_8',
              defaultMessage: '다음 퀴즈를 삭제합니까?'
            })
          )}
        </div>
        <Message className={cx('template-detail-box')}>
          {/* <Message.Header>
            {defineMessages(
              formatMessage({
                id: 'ExamAttachDelete_2',
                defaultMessage: '삭제한 첨부파일은 복구할 수 없습니다. 다음 첨부파일을 삭제합니까?'
              })
            )}
          </Message.Header> */}
          <div className={cx('template-detail')}>
            <List bulleted className={cx('template-detail-list')}>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>No</div>
                {quizInfo.quizNo}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'Quiz_2', defaultMessage: '퀴즈 내용' }))}
                </div>
                {quizInfo.quizContent}
              </List.Item>
              {/* <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ExamAttachDelete_4', defaultMessage: '등록일' }))}
                </div>
                {common.timeFormatFromUTCEpoch(regEpoch)}
              </List.Item> */}
            </List>
          </div>
        </Message>
      </ModalTemplate>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  EduActions: bindActionCreators(eduActions, dispatch)
});

export default connect(null, mapDispatchToProps)(injectIntl(EduQuizDeleteModal));


// WEBPACK FOOTER //
// ./src/script/components/edu/EduQuizDeleteModal.js